module.exports = __webpack_public_path__ + "img/game--sims-4--esrb.bb81d449.png";